import { LIST_ROWS_PER_PAGE } from '../constants';
import { formatDate, MOMENT_FORMATS } from './dateFormat';

export const formatUserGender = (value) => {
  if (value == null || value === '') return '—';
  const normalized = String(value).trim().toLowerCase();
  if (normalized === 'male') return 'Male';
  if (normalized === 'female') return 'Female';
  if (normalized === 'other') return 'Other';
  return String(value).trim();
};

export const normalizeAppUserInterests = (interests) => {
  if (!Array.isArray(interests)) return [];

  return interests
    .map((interest, index) => {
      if (typeof interest === 'string') {
        const label = interest.trim();
        return label ? { id: label, label, category: null } : null;
      }

      if (!interest || typeof interest !== 'object') return null;

      const label = String(interest.label ?? interest.name ?? '').trim();
      if (!label) return null;

      return {
        id: interest.id ?? `interest-${index}`,
        label,
        category: interest.category ?? null,
      };
    })
    .filter(Boolean);
};

export const formatAppUserJoinedAt = (createdAt) => {
  if (createdAt == null || createdAt === '') return '—';

  const raw = String(createdAt).trim();
  const isPartnerTimestamp = /^\d{2}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/.test(raw);

  return (
    formatDate(
      createdAt,
      MOMENT_FORMATS.DATETIME,
      isPartnerTimestamp ? MOMENT_FORMATS.PARTNER_API : undefined,
    ) || '—'
  );
};

/** Normalize a platform user row from GET /admin/app-users. */
export const normalizeAppUser = (user = {}) => ({
  id: user.id ?? user.userId ?? user._id ?? user.userEmail ?? null,
  fullName: user.fullName ?? '',
  userEmail: user.userEmail ?? user.email ?? '',
  avatarUrl: user.avatarUrl ?? null,
  phoneNumber: user.phoneNumber ?? '',
  profession: user.profession ?? '',
  location: user.location ?? '',
  gender: user.gender ?? '',
  createdAt: user.createdAt ?? user.created_at ?? null,
  profileVerified: Boolean(user.isProfileVerified ?? user.profileVerified),
  onboardingCompleted: Boolean(user.onboardingCompleted),
  isBanned: Boolean(user.isBanned),
  interests: normalizeAppUserInterests(user.interests),
});

export const normalizeAppUsersListResponse = (payload, params = {}) => {
  const root = payload?.data ?? payload ?? {};
  const users = (root.users ?? []).map(normalizeAppUser);
  const limit = Number(root.limit ?? params.limit ?? LIST_ROWS_PER_PAGE);
  const total = Number(root.total ?? users.length);
  const page = Number(root.page ?? params.page ?? 1);
  const totalPages = Number(root.totalPages ?? Math.max(1, Math.ceil(total / Math.max(limit, 1))));

  return {
    users,
    total,
    page,
    limit,
    totalPages,
  };
};
